import { ActiveSessionsPage } from '@zzk/admin-pages';
import type { AuthAdminSession } from '@zzk/auth';
import { createElement, type ReactNode } from 'react';

export interface SettingsSessionsViewOptions {
  readonly sessions: readonly AuthAdminSession[];
  readonly onRevoke?: (sessionId: string) => void;
  readonly revokeActions?: ReactNode;
}

export function toSettingsSessionRow(session: AuthAdminSession) {
  return {
    id: session.id,
    device: `Session ${session.id.slice(0, 8)}`,
    createdAt: session.createdAt,
    lastSeenAt: session.expiresAt,
    current: false,
  };
}

export function createSettingsSessionsView(
  options: SettingsSessionsViewOptions,
) {
  const { sessions, revokeActions } = options;
  const rows = sessions.map(toSettingsSessionRow);

  return createElement(ActiveSessionsPage, {
    sessions: rows,
    actions: revokeActions,
    'data-zzk-settings-sessions': true,
  } as Parameters<typeof ActiveSessionsPage>[0]);
}

export function createSettingsSessionsState(
  sessions: readonly AuthAdminSession[],
) {
  return {
    sessions,
    rows: sessions.map(toSettingsSessionRow),
    isEmpty: sessions.length === 0,
  };
}
